import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { isWebView } from '@front-core/utils';
import { clsx } from 'clsx';
import styles from './gridWithStickyAside.scss';
const LayoutGridWithStickyAside = ({ mainContent, asideContent }) => _jsxs("div", { className: clsx(styles.container, {
        [styles.isWebView]: isWebView()
    }), "data-sentry-component": "LayoutGridWithStickyAside", "data-sentry-source-file": "index.tsx", children: [_jsx("div", { className: styles.mainContainer, children: mainContent }), asideContent ? _jsx("aside", { className: styles.aside, children: asideContent }) : null] });
export default LayoutGridWithStickyAside;
